import { Outlet, createRootRouteWithContext, useLocation } from '@tanstack/react-router';
import { Suspense } from 'react';
import type { ContextoRuta } from '../nucleo/autorizacion/guardian.js';
import { Marco } from '../ui/navegacion/Marco.js';
import { AvisoPedidosPerezoso } from './aviso-pedidos.js';
import { gruposVisibles } from '../ui/navegacion/mapa.js';

/**
 * La raíz dibuja el `Outlet`, y alrededor el menú cuando hay a dónde ir.
 *
 * El `QueryClientProvider` estaba acá y se movió a `consultas.tsx`, que cargan los tres
 * grupos a pedido. La razón es medida: la raíz la importa el punto de entrada, así que
 * todo lo que cuelgue de ella viaja en el primer fragmento, y `@tanstack/query` son 7,5 KB
 * comprimidos que la pantalla de ingreso no usa. Quien entra y no llega a pasar del
 * ingreso no tiene por qué descargarlos.
 *
 * EL MENÚ SÍ VIAJA EN EL PRIMER FRAGMENTO, a propósito y medido: lo usan todas las pantallas
 * con sesión, así que diferirlo sólo movería su peso a la primera navegación y le agregaría un
 * parpadeo. Lo que usa, `evaluarGuardian`, ya estaba ahí porque lo importan los cuatro grupos.
 *
 * SIN MENÚ EN LAS DOS PANTALLAS PÚBLICAS, ni sin sesión, ni con la contraseña temporal
 * pendiente: en los tres casos no hay ningún grupo que se pueda abrir, y un menú vacío o lleno
 * de puertas que rebotan es peor que ninguno.
 */
const PUBLICAS = new Set(['/ingresar', '/cambiar-password']);

// A pedido: sólo lo ve el super administrador, y en estática le sumaba nueve kilobytes al camino
// crítico del operario, que nunca lo muestra. Trae su propio proveedor de consultas.


export const rutaRaiz = createRootRouteWithContext<ContextoRuta>()({
  component: function Raiz() {
    const { sesion } = rutaRaiz.useRouteContext();
    const { pathname } = useLocation();

    if (!sesion || PUBLICAS.has(pathname) || gruposVisibles(sesion).length === 0) {
      return <Outlet />;
    }
    return (
      <Marco sesion={sesion} aviso={sesion.superAdministrador ? <Suspense fallback={null}><AvisoPedidosPerezoso /></Suspense> : null}>
        <Outlet />
      </Marco>
    );
  },
});
